import { Text, TextProps } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { FC } from 'react';

const Title = styled(Text)`
  display: block;
`;

const PageTitle: FC<TextProps> = ({ children, ...props }) => (
  <Title as="h2" layerStyle="pageTitle" {...props}>
    {children}
  </Title>
);

export default PageTitle;
